import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import GlobalFooter from "./GlobalFooter";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var childrenNode, reactifiedChildren, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            childrenNode = domNode.querySelector("[data-rehydratable-children]");
            _context.next = 3;
            return rehydrateChildren(childrenNode);

          case 3:
            reactifiedChildren = _context.sent;
            props = {
              logoHref: domNode.getAttribute("data-logo-href"),
              logoText: domNode.getAttribute("data-logo-text")
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(GlobalFooter, props, reactifiedChildren));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();